import bannerReducer from "../reducers/Admin/bannerActions";
import blogReducer from "../reducers/Admin/blogActions";
import caseStudyReducer from "../reducers/Admin/caseStudyActions";
import categoriesReducer from "../reducers/Admin/categoriesActions";
import clientReducer from "../reducers/Admin/clientActions";
import { configureStore } from "@reduxjs/toolkit";
import contactFormReducer from "../reducers/Admin/contactFormActions";
import documentReducer from "../reducers/Admin/documentActions";
import globalReducer from "../reducers/Site/globalActions";
import newsletterReducer from "../reducers/Admin/newsletterActions";
import productReducer from "../reducers/Admin/productActions";
import qaReducer from "../reducers/Admin/qaActions";
import resourcesReducer from "../reducers/Admin/resourcesActions";
import roleReducer from "../reducers/Admin/roleActions";
import securityReducer from "./security";
import seoReducer from "../reducers/Admin/seoActions";
import sliderReducer from "../reducers/Admin/sliderActions";
import teamReducer from "../reducers/Admin/teamActions";
import testimonialsReducer from "../reducers/Admin/testimonialsActions";
import userReducer from "../reducers/Admin/userActions";

const store = configureStore({
  reducer: {
    loggedUserReducer: securityReducer,
    seoReducer,
    qaReducer,
    documentReducer,
    clientReducer,
    blogReducer,
    caseStudyReducer,
    contactFormReducer,
    roleReducer,
    categoriesReducer,
    userReducer,
    testimonialsReducer,
    globalReducer,
    teamReducer,
    productReducer,
    resourcesReducer,
    newsletterReducer,
    sliderReducer,
    bannerReducer,
  },
});

export default store;
